import settings from '@/constants/constants';
import { usePreOnboardingContext } from '@/hooks/escript/usePreOnboardingContext';
import { LOGIN_ROUTE } from '@/routes/route-paths';
import { Button, Link, Stack } from '@montugroup/design-system';
import { styled } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const OnboardingMenuDesktopLinks = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(6),
  alignItems: 'center',
}));

const FaqLink = styled(Link)(({ theme }) => ({
  marginRight: theme.spacing(8.5),
  fontWeight: 600,
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.common.black,
  },
}));

export function OnboardingMenuDesktop() {
  const { resetOnboardingState } = usePreOnboardingContext();
  return (
    <OnboardingMenuDesktopLinks direction="row">
      <FaqLink href={`${settings.marketing.site.url}/faq`} rel="noopener noreferrer" target="_blank">
        FAQs
      </FaqLink>
      <Button
        component={RouterLink}
        to={LOGIN_ROUTE}
        variant="outlined"
        color="primary"
        size="large"
        data-tracking-id="escript_onboarding_header_login_desktop"
      >
        Sign In
      </Button>

      <Button
        variant="contained"
        color="primary"
        size="large"
        data-tracking-id="escript_onboarding_header_prescription_desktop"
        onClick={resetOnboardingState}
      >
        Submit Prescription
      </Button>
    </OnboardingMenuDesktopLinks>
  );
}
